import React, { useState } from 'react';
import { Navigation } from '../components/Navigation';
import { CalendarIcon } from 'lucide-react';
import { PersonaSwitcher } from '../components/appointments/PersonaSwitcher';
import { AppointmentCalendar } from '../components/appointments/AppointmentCalendar';
import { BookingForm } from '../components/appointments/BookingForm';
import { DoctorSchedule } from '../components/appointments/DoctorSchedule';
import { RoomBooking } from '../components/appointments/RoomBooking';
import { NotificationSettings } from '../components/appointments/NotificationSettings';
import { AppointmentList } from '../components/appointments/AppointmentList';
export function AppointmentManagement() {
  const [persona, setPersona] = useState<'patient' | 'receptionist'>('patient');
  const [activeView, setActiveView] = useState<'calendar' | 'book' | 'list' | 'doctors' | 'rooms' | 'notifications'>('calendar');
  return <div className="min-h-screen bg-gray-50 w-full" data-id="element-1351">
      <Navigation data-id="element-1352" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1353">
        <div className="flex items-center justify-between mb-6" data-id="element-1354">
          <div className="flex items-center space-x-3" data-id="element-1355">
            <CalendarIcon className="w-8 h-8 text-blue-600" data-id="element-1356" />
            <div data-id="element-1357">
              <h1 className="text-3xl font-bold text-gray-900" data-id="element-1358">
                Appointment Management
              </h1>
              <p className="text-gray-600" data-id="element-1359">
                Multi-channel appointment scheduling and management
              </p>
            </div>
          </div>
          <PersonaSwitcher persona={persona} setPersona={setPersona} data-id="element-1360" />
        </div>
        {/* Navigation Tabs */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-6" data-id="element-1361">
          <div className="flex overflow-x-auto" data-id="element-1362">
            <button onClick={() => setActiveView('calendar')} className={`px-6 py-3 text-sm font-medium whitespace-nowrap ${activeView === 'calendar' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-1363">
              Calendar View
            </button>
            <button onClick={() => setActiveView('book')} className={`px-6 py-3 text-sm font-medium whitespace-nowrap ${activeView === 'book' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-1364">
              Book Appointment
            </button>
            <button onClick={() => setActiveView('list')} className={`px-6 py-3 text-sm font-medium whitespace-nowrap ${activeView === 'list' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-1365">
              My Appointments
            </button>
            <button onClick={() => setActiveView('doctors')} className={`px-6 py-3 text-sm font-medium whitespace-nowrap ${activeView === 'doctors' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-1366">
              Doctor Schedules
            </button>
            <button onClick={() => setActiveView('rooms')} className={`px-6 py-3 text-sm font-medium whitespace-nowrap ${activeView === 'rooms' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-1367">
              Room Booking
            </button>
            <button onClick={() => setActiveView('notifications')} className={`px-6 py-3 text-sm font-medium whitespace-nowrap ${activeView === 'notifications' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-1368">
              Notifications
            </button>
          </div>
        </div>
        {/* Content Area */}
        <div data-id="element-1369">
          {activeView === 'calendar' && <AppointmentCalendar persona={persona} data-id="element-1370" />}
          {activeView === 'book' && <BookingForm persona={persona} data-id="element-1371" />}
          {activeView === 'list' && <AppointmentList persona={persona} data-id="element-1372" />}
          {activeView === 'doctors' && <DoctorSchedule persona={persona} data-id="element-1373" />}
          {activeView === 'rooms' && <RoomBooking persona={persona} data-id="element-1374" />}
          {activeView === 'notifications' && <NotificationSettings persona={persona} data-id="element-1375" />}
        </div>
      </div>
    </div>;
}